import React from 'react';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-white px-5 py-20" data-id="element-204" data-mp="20rp0nzirde8y">
      <div className="mx-auto max-w-6xl" data-id="element-205" data-mp="20tjktbm7h2bz">
        <div className="text-center" data-id="element-206" data-mp="1n0k81hdt5m84">
          <p className="text-[11px] font-semibold uppercase tracking-[.22em] text-sage-700" data-id="element-207" data-mp="1mzit31to8fl4">
            Trusted by 1,500+ functional coaches
          </p>
          <h2 className="mt-4 font-display text-[2.1rem] font-semibold uppercase leading-[1.02] tracking-[.01em] text-ink-900 sm:text-5xl" data-id="element-208" data-mp="1d1bhyzm2crr1">
            What coaches are saying
          </h2>
          <p className="mt-3 text-sm font-semibold text-ink-600" data-id="element-209" data-mp="141g1cf9qo4jm">
            ★★★★★ 4.9/5 · 1,500+ professionals
          </p>
        </div>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-210" data-mp="183jed8c23h70">
          {testimonials.map(({
          initials,
          quote,
          name,
          role
        }) => <figure key={name} className="flex min-h-[250px] flex-col border border-line bg-stone-50 p-7" data-id="element-211" data-mp="32gsqz8zwfith">
              <div className="flex items-center gap-3" data-id="element-212" data-mp="2v09oephtx456">
                <span className="grid h-10 w-10 place-items-center rounded-full bg-ink-900 text-[11px] font-semibold text-white" data-id="element-213" data-mp="2q2hob8716bpw">
                  {initials}
                </span>
                <span className="text-clay-500" aria-label="5 out of 5 stars" data-id="element-214" data-mp="34t8de8h8mwpb">
                  ★★★★★
                </span>
              </div>
              <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-ink-800" data-id="element-215" data-mp="2c1x4c8pdq9ut">
                “{quote}”
              </blockquote>
              <figcaption className="mt-auto pt-5" data-id="element-216" data-mp="275q6z4b1u6oh">
                <p className="text-sm font-semibold text-ink-900" data-id="element-217" data-mp="2m162ldra2amz">{name}</p>
                <p className="text-xs text-ink-600" data-id="element-218" data-mp="2h22wdpzk9ydf">{role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}